module.exports = __webpack_public_path__ + "static/img/best_costume_design_block_11.8fa49a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/best_costume_design_block_11.jpg
// module id = 235
// module chunks = 0